export const REVISION_STATUS = {
  REPORT: 'REPORT',
  TRANSCRIPT_REVIEW_ITEM: 'TRANSCRIPT_REVIEW_ITEM',
};
